/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".ring-title[_ngcontent-%COMP%]{font-weight:700}.groups[_ngcontent-%COMP%] > div[_ngcontent-%COMP%]{font-size:3vh;display:inline-block;padding:0 10px}\n/*# sourceMappingURL=ring.component.css.map*/"];
export { styles as styles };
